var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "page-outline",
    { attrs: { title: _vm.$t("administration.company_dtls") } },
    [
      _c(
        "template",
        { slot: "pageContent" },
        [
          this.$engine.firstOn().company.redirection === "0"
            ? _c(
                "b-row",
                { staticClass: "pb-3 mx-0" },
                [_c("back-button", { attrs: { returnUrl: _vm.returnUrl } })],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.activateSpinner
            ? _c("spinner")
            : _c(
                "div",
                [
                  _vm.CompaniesList.length > 0
                    ? [
                        _c("div", { staticClass: "title-label-blue w-200px" }, [
                          _vm._v(_vm._s(_vm.$t("administration.company_info"))),
                        ]),
                        _vm._v(" "),
                        _c("table", { staticClass: "table" }, [
                          _c("tbody", [
                            _c("tr", [
                              _c("th", { staticClass: "text-center w-50" }, [
                                _vm._v(
                                  "\n                " +
                                    _vm._s(
                                      _vm.$t("administration.company_id")
                                    ) +
                                    "\n              "
                                ),
                              ]),
                              _vm._v(" "),
                              _c("td", { staticClass: "text-center w-50" }, [
                                _vm._v(
                                  "\n                " +
                                    _vm._s(
                                      _vm.CompaniesList[0].account.identifier
                                    ) +
                                    "\n              "
                                ),
                              ]),
                            ]),
                            _vm._v(" "),
                            _c("tr", [
                              _c("th", { staticClass: "text-center w-50" }, [
                                _vm._v(
                                  "\n                " +
                                    _vm._s(
                                      _vm.$t("administration.company_name")
                                    ) +
                                    "\n              "
                                ),
                              ]),
                              _vm._v(" "),
                              _c("td", { staticClass: "text-center w-50" }, [
                                _vm._v(
                                  "\n                " +
                                    _vm._s(_vm.CompaniesList[0].account.name) +
                                    "\n              "
                                ),
                              ]),
                            ]),
                            _vm._v(" "),
                            _c("tr", [
                              _c("th", { staticClass: "text-center w-50" }, [
                                _vm._v(
                                  "\n                " +
                                    _vm._s(
                                      _vm.$t("administration.company_email")
                                    ) +
                                    "\n              "
                                ),
                              ]),
                              _vm._v(" "),
                              _c("td", { staticClass: "text-center w-50" }, [
                                _vm._v(
                                  "\n                " +
                                    _vm._s(
                                      _vm.CompaniesList[0].account
                                        .email_reference
                                    ) +
                                    "\n              "
                                ),
                              ]),
                            ]),
                            _vm._v(" "),
                            _c("tr", [
                              _c("th", { staticClass: "text-center w-50" }, [
                                _vm._v(
                                  "\n                " +
                                    _vm._s(_vm.$t("administration.active")) +
                                    "\n              "
                                ),
                              ]),
                              _vm._v(" "),
                              _c("td", { staticClass: "text-center w-50" }, [
                                _vm.CompaniesList[0].active == 0
                                  ? _c("i", {
                                      staticClass:
                                        "fa-duotone fa-xmark btn-icon text-danger p-0",
                                    })
                                  : _vm._e(),
                                _vm._v(" "),
                                _vm.CompaniesList[0].active == 2
                                  ? _c("i", {
                                      staticClass:
                                        "fa-duotone fa-check btn btn-icon text-success p-0",
                                    })
                                  : _vm._e(),
                                _vm._v(" "),
                                _vm.CompaniesList[0].active == 1
                                  ? _c("i", {
                                      staticClass:
                                        "fa-duotone fa-warning btn btn-icon text-warning p-0",
                                    })
                                  : _vm._e(),
                              ]),
                            ]),
                          ]),
                        ]),
                      ]
                    : _vm._e(),
                  _vm._v(" "),
                  _c("br"),
                  _vm._v(" "),
                  _c("div", { staticClass: "title-label-blue w-200px" }, [
                    _vm._v(_vm._s(_vm.$t("administration.company_users"))),
                  ]),
                  _vm._v(" "),
                  _c("b-table", {
                    ref: "userList",
                    staticClass: "mt-3",
                    attrs: {
                      hover: "",
                      fixed: "",
                      responsive: "",
                      fields: _vm.userListFields,
                      items: _vm.CompaniesList[0].users,
                      selectable: _vm.CompaniesList[0].users.length > 0,
                      "sort-by": _vm.sortBy,
                      "empty-text": _vm.$t("errors.No_results_found"),
                    },
                    on: {
                      "update:sortBy": function ($event) {
                        _vm.sortBy = $event
                      },
                      "update:sort-by": function ($event) {
                        _vm.sortBy = $event
                      },
                      "row-selected": _vm.seeDetailsUser,
                    },
                    scopedSlots: _vm._u([
                      {
                        key: "cell(login)",
                        fn: function (data) {
                          return [
                            _c("div", { staticClass: "cursor text-ellipsis" }, [
                              _vm._v(_vm._s(data.value)),
                            ]),
                          ]
                        },
                      },
                      {
                        key: "cell(name)",
                        fn: function (data) {
                          return [
                            !data.value
                              ? _c("div", [_vm._v("-")])
                              : _c(
                                  "div",
                                  { staticClass: "cursor text-ellipsis" },
                                  [_vm._v(_vm._s(data.value))]
                                ),
                          ]
                        },
                      },
                    ]),
                  }),
                  _vm._v(" "),
                  _vm.canAddUser
                    ? _c(
                        "b-row",
                        { staticClass: "no-gutter d-flex justify-content-end" },
                        [
                          _c(
                            "b-button",
                            {
                              attrs: { variant: "primary" },
                              on: { click: _vm.addUser },
                            },
                            [
                              _c("i", { staticClass: "fa-light fa-plus" }),
                              _vm._v(" "),
                              _c("span", [
                                _vm._v(
                                  _vm._s(_vm.$t("administration.user_add"))
                                ),
                              ]),
                            ]
                          ),
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _c("br"),
                  _vm._v(" "),
                  _c("div", { staticClass: "title-label-blue w-200px" }, [
                    _vm._v(_vm._s(_vm.$t("administration.company_prfls"))),
                  ]),
                  _vm._v(" "),
                  _c("table", { staticClass: "table" }, [
                    _c("thead", [
                      _c("th", { staticClass: "text-center w-200px" }, [
                        _vm._v(
                          "\n            " +
                            _vm._s(_vm.$t("administration.label")) +
                            "\n          "
                        ),
                      ]),
                    ]),
                    _vm._v(" "),
                    _c(
                      "tbody",
                      [
                        _vm.CompaniesList.length > 0
                          ? _vm._l(_vm.filteredProfiles, function (result) {
                              return _c("tr", [
                                _c(
                                  "td",
                                  {
                                    staticClass: "text-center",
                                    attrs: { title: result.libelle },
                                  },
                                  [_vm._v(_vm._s(result.libelle))]
                                ),
                              ])
                            })
                          : _c("tr", [
                              _c(
                                "td",
                                {
                                  staticClass: "noResult",
                                  attrs: { colspan: "6" },
                                },
                                [
                                  _vm._v(
                                    "\n              " +
                                      _vm._s(_vm.$t("common.no_result")) +
                                      "\n            "
                                  ),
                                ]
                              ),
                            ]),
                      ],
                      2
                    ),
                  ]),
                  _vm._v(" "),
                  _c("br"),
                  _vm._v(" "),
                  _c("div", { staticClass: "title-label-blue w-200px" }, [
                    _vm._v(_vm._s(_vm.$t("administration.company_rights"))),
                  ]),
                  _vm._v(" "),
                  _c("table", { staticClass: "table text-center" }, [
                    _c("thead", [
                      _c("th", [
                        _vm._v(
                          "\n            " +
                            _vm._s(_vm.$t("administration.right_list")) +
                            "\n          "
                        ),
                      ]),
                    ]),
                    _vm._v(" "),
                    _c(
                      "tbody",
                      [
                        _vm.CompaniesList.length > 0
                          ? _vm._l(
                              _vm.CompaniesList[0].rights,
                              function (result) {
                                return _c("tr", [
                                  _c(
                                    "td",
                                    {
                                      attrs: {
                                        title:
                                          _vm.$t(
                                            "rights.db_rights." + result
                                          ) ===
                                          "rights.db_rights." + result
                                            ? result
                                            : _vm.$t(
                                                "rights.db_rights." + result
                                              ),
                                      },
                                    },
                                    [
                                      _vm._v(
                                        "\n                " +
                                          _vm._s(
                                            _vm.$t(
                                              "rights.db_rights." + result
                                            ) ===
                                              "rights.db_rights." + result
                                              ? result
                                              : _vm.$t(
                                                  "rights.db_rights." + result
                                                )
                                          ) +
                                          "\n              "
                                      ),
                                    ]
                                  ),
                                ])
                              }
                            )
                          : _c("tr", [
                              _c(
                                "td",
                                {
                                  staticClass: "noResult",
                                  attrs: { colspan: "6" },
                                },
                                [
                                  _vm._v(
                                    "\n              " +
                                      _vm._s(_vm.$t("common.no_result")) +
                                      "\n            "
                                  ),
                                ]
                              ),
                            ]),
                      ],
                      2
                    ),
                  ]),
                  _vm._v(" "),
                  _c("br"),
                  _vm._v(" "),
                  _vm.canCompanyDelete || _vm.canCompanyEdit
                    ? _c(
                        "b-row",
                        { staticClass: "justify-content-end no-gutters" },
                        [
                          _vm.canCompanyDelete
                            ? _c(
                                "div",
                                { staticClass: "deleteUser" },
                                [
                                  _c(
                                    "b-button",
                                    {
                                      staticClass: "btn btn-sm mr-3",
                                      attrs: { variant: "primary" },
                                      on: {
                                        click: function ($event) {
                                          return _vm.activateCompanyDelete(
                                            _vm.CompaniesList[0].idCompany
                                          )
                                        },
                                      },
                                    },
                                    [
                                      _c("i", {
                                        staticClass: "fa-light fa-trash",
                                      }),
                                      _vm._v(
                                        "  " +
                                          _vm._s(
                                            _vm.$t(
                                              "administration.company_delete"
                                            )
                                          ) +
                                          "\n          "
                                      ),
                                    ]
                                  ),
                                ],
                                1
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.canCompanyEdit
                            ? _c(
                                "div",
                                { staticClass: "editUser" },
                                [
                                  _c(
                                    "b-button",
                                    {
                                      staticClass: "btn btn-sm",
                                      attrs: { variant: "primary" },
                                      on: {
                                        click: function ($event) {
                                          return _vm.activateCompanyEdit(
                                            _vm.CompaniesList[0].idCompany
                                          )
                                        },
                                      },
                                    },
                                    [
                                      _c("i", {
                                        staticClass: "fa-light fa-pencil",
                                      }),
                                      _vm._v(
                                        "  " +
                                          _vm._s(
                                            _vm.$t(
                                              "administration.company_edit"
                                            )
                                          ) +
                                          "\n          "
                                      ),
                                    ]
                                  ),
                                ],
                                1
                              )
                            : _vm._e(),
                        ]
                      )
                    : _vm._e(),
                ],
                2
              ),
        ],
        1
      ),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }